/**
 * FAQ page template accordion (first item open by default).
 */
document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.faq-page-template .faq-item');
    if (!items.length) return;

    function setOpen(item, open) {
        item.classList.toggle('active', open);
        item.querySelector('.faq-item-content').style.display = open ? 'block' : 'none';
        item.querySelector('.plus').style.display = open ? 'none' : 'inline';
        item.querySelector('.minus').style.display = open ? 'inline' : 'none';
    }

    setOpen(items[0], true);

    document.querySelectorAll('.faq-page-template .faq-item-header').forEach(function (header) {
        header.addEventListener('click', function () {
            var parent = this.parentElement;
            var content = parent.querySelector('.faq-item-content');
            var isClosed = content.style.display === 'none' || content.style.display === '';

            items.forEach(function (other) {
                if (other !== parent) setOpen(other, false);
            });
            setOpen(parent, isClosed);
        });
    });
});
